/* eslint-disable unicorn/consistent-function-scoping */
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { OnboardingVideoComponent } from 'libs/onboarding/src/lib/onboarding-modal/steps/onboarding-video/onboarding-video.component';
import { PreviewVideoModule } from '@libs/media-preview';
import { SiteSetupComponentService } from '../site-setup/site-setup.component.service';
import { siteSetupVideos } from '../site-setup-videos';
import { SiteSetupNavbarComponent } from '../site-setup/components/site-setup-navbar/site-setup-navbar.component';
import { FaqCardComponent } from './faq-card/faq-card.component';

@Component({
  selector: 'lib-site-install-help',
  imports: [
    CommonModule,
    TranslateModule,
    CdkAccordionModule,
    FaqCardComponent,
    OnboardingVideoComponent,
    SiteSetupNavbarComponent,
    PreviewVideoModule,
  ],
  templateUrl: './site-install-help.component.html',
  styleUrl: './site-install-help.component.scss',
})
export class SiteInstallHelpComponent {
  public siteSetupComponentService = inject(SiteSetupComponentService);
  private readonly translateService = inject(TranslateService);
  private readonly router = inject(Router);
  public vm = this.siteSetupComponentService.viewModel;

  public faqs = [
    {
      question: this.translateService.instant('site_setup_faq_question1'),
      answer: this.translateService.instant('site_setup_faq_answer1'),
    },
    {
      question: this.translateService.instant('site_setup_faq_question2'),
      answer: this.translateService.instant('site_setup_faq_answer2'),
    },
    {
      question: this.translateService.instant('site_setup_faq_question3'),
      answer: this.translateService.instant('site_setup_faq_answer3'),
    },
    {
      question: this.translateService.instant('site_setup_faq_question4'),
      answer: this.translateService.instant('site_setup_faq_answer4'),
    },
  ];

  protected videos = siteSetupVideos;
}
